import notifications from "./notifications";
import credentials from "./credentials";

const data = [
  ...notifications,
  ...credentials,
];

export default data;
